export default __webpack_public_path__ + "static/media/plop.1d3f6988.mp3";